import React from 'react'

import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import KinerjaDinasIndex from 'app/KinerjaDinasPage/pages/Index'
import PageGuardDinas from 'app/KinerjaDinasPage/components/PageGuardDinas'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'
import { KinerjaTipeProvider } from 'app/KinerjaShared/components/KinerjaTipeProvider'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const enabled = toggle?.['kinerja-dinas-enabled'] || false

    if (!enabled) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }
  },
})

const Page = () => (
  <PageGuardDinas>
    <KinerjaTipeProvider tipe="SPF">
      <KinerjaDinasIndex />
    </KinerjaTipeProvider>
  </PageGuardDinas>
)

Page.Layout = KinerjaLayout

Page.layoutOpts = {
  hasHeader: true,
}

export default Page
